module.exports = __webpack_public_path__ + "img/etiquetado10.79439cc7.jpg";